import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import {
  Alert as MuiAlert,
  type AlertProps as MuiAlertProps,
} from '@mui/material';
import { useThemeTokens } from '@providers/themeTokenProvider';
import { merge } from 'lodash-es';
import { useAlertTokens } from './alert.tokens';

interface AlertProps extends MuiAlertProps {
  comp?: any;
}

export const Alert = (props: AlertProps): JSX.Element => {
  const iconSelection = (alertSeverity: string) => {
    switch (alertSeverity) {
      case 'info':
        return <InfoIcon />;
      case 'success':
        return <CheckCircleIcon />;
      case 'warning':
        return <WarningIcon />;
      case 'error':
        return <ErrorIcon />;
      default:
        return <InfoIcon />;
    }
  };

  const variant = props.variant || 'outlined';
  const severity = props.severity || 'info';
  const icon = props.icon || iconSelection(severity);

  const { comp: compToken } = useThemeTokens(useAlertTokens());
  const comp = merge({}, compToken, props.comp);

  const internalSx = {
    ...comp?.alert[variant][severity],
    color: comp?.alert[variant][severity].fontColor,
    '& .MuiAlert-icon': {
      color: comp?.alert[variant][severity].color,
    },
    '&.MuiAlert-outlined': {
      borderColor: comp?.alert[variant][severity].borderColor,
    },
  };

  const combinedSx = props.sx ? merge({}, props.sx, internalSx) : internalSx;

  return (
    <MuiAlert sx={combinedSx} icon={icon} variant={variant} {...props}>
      {props?.children || ''}
    </MuiAlert>
  );
};
